import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shell", "brandName", "brandLink", "navLinks", "localeToggle", "primaryCta"]
  static values = { light: { type: Boolean, default: false } }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const compact = window.innerWidth >= 768 && window.scrollY > 12

    if (this.lightValue) {
      this.#applyLightShell(compact)
    } else {
      this.#applyDarkShell(compact)
    }

    this.#applySharedCompact(compact)
  }

  #applyDarkShell(compact) {
    const s = this.shellTarget
    s.classList.remove(
      "bg-white/95", "bg-white/85", "border-black/10", "border-black/15",
      "shadow-sm", "shadow-md", "max-w-7xl"
    )

    s.classList.toggle("bg-black/90", !compact)
    s.classList.toggle("bg-black/55", compact)
    s.classList.toggle("backdrop-blur-none", !compact)
    s.classList.toggle("backdrop-blur-md", compact)
    s.classList.toggle("border-[#1f1f1f]", !compact)
    s.classList.toggle("border-white/10", compact)
    s.classList.toggle("max-w-5xl", !compact)
    s.classList.toggle("max-w-[800px]", compact)
    s.style.height = compact ? "46px" : "52px"
  }

  #applyLightShell(compact) {
    const s = this.shellTarget
    s.classList.remove(
      "bg-black/90", "bg-black/55", "border-[#1f1f1f]", "border-white/10",
      "max-w-5xl", "max-w-[800px]"
    )

    s.classList.add("max-w-7xl")
    s.classList.toggle("bg-white/95", !compact)
    s.classList.toggle("bg-white/85", compact)
    s.classList.toggle("backdrop-blur-none", !compact)
    s.classList.toggle("backdrop-blur-md", compact)
    s.classList.toggle("border-black/10", !compact)
    s.classList.toggle("border-black/15", compact)
    s.classList.toggle("shadow-sm", !compact)
    s.classList.toggle("shadow-md", compact)
    s.style.height = compact ? "46px" : "52px"
  }

  #applySharedCompact(compact) {
    this.brandNameTarget.classList.toggle("opacity-100", !compact)
    this.brandNameTarget.classList.toggle("max-w-[180px]", !compact)
    this.brandNameTarget.classList.toggle("ml-0", !compact)
    this.brandNameTarget.classList.toggle("opacity-0", compact)
    this.brandNameTarget.classList.toggle("max-w-0", compact)
    this.brandNameTarget.classList.toggle("-ml-2", compact)

    this.brandLinkTarget.classList.toggle("text-base", !compact)
    this.brandLinkTarget.classList.toggle("text-[15px]", compact)

    this.navLinksTarget.classList.toggle("text-sm", !compact)
    this.navLinksTarget.classList.toggle("text-[13px]", compact)
    this.navLinksTarget.classList.toggle("gap-7", !compact)
    this.navLinksTarget.classList.toggle("gap-6", compact)

    this.localeToggleTarget.classList.toggle("scale-100", !compact)
    this.localeToggleTarget.classList.toggle("scale-95", compact)

    this.primaryCtaTarget.classList.toggle("px-5", !compact)
    this.primaryCtaTarget.classList.toggle("py-2", !compact)
    this.primaryCtaTarget.classList.toggle("text-sm", !compact)
    this.primaryCtaTarget.classList.toggle("px-4", compact)
    this.primaryCtaTarget.classList.toggle("py-1.5", compact)
    this.primaryCtaTarget.classList.toggle("text-[13px]", compact)
  }
}
